import React from "react";
import { useParams, Navigate } from "react-router-dom";
import SessionHub from "views/admin/sessions/SessionHub";

const CenterSessionsMgmt = () => {
  const { centerId } = useParams<{ centerId: string }>();

  if (!centerId) return <Navigate to="/systemadmin/centers" replace />;

  return <SessionHub centerId={centerId} classBasePath={`/systemadmin/centers/${centerId}/classes`} />;
};

export default CenterSessionsMgmt;
